import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Link, useLocation, useHistory } from 'react-router-dom'
import { MapRouteToStep, MapStepToRoute, PASO_MAXIMO } from '../utils/steps'
import { StepContext } from '../StepContext'

const DeclaracionJurada = (props) => {
  const { puedeAvanzar, callbackAvance, setPuedeAvanzar } =
    useContext(StepContext)
  const [cargandoCallback, setCargandoCallback] = useState(false)
  const [paso, setPaso] = useState(1)
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    const route = location.pathname
    setPaso(MapRouteToStep(route))
  }, [location.pathname])

  useEffect(() => {
    const route = location.pathname
    setPaso(MapRouteToStep(route))
  }, [location.pathname])

  const avanzarPaso = async (callback = null) => {
    let puedeAvanzar = false
    setCargandoCallback(true)
    if (callback)
      await callback().then((resultado) => {
        puedeAvanzar = resultado
      })
    if (puedeAvanzar === true) {
      const pasoAContinuar = paso >= PASO_MAXIMO ? PASO_MAXIMO : paso + 1
      setPuedeAvanzar(false)
      setPaso(pasoAContinuar)
      history.push(MapStepToRoute(`P${pasoAContinuar}`))
    } else {
      console.log('Ocurrio un error: ' + puedeAvanzar)
    }
    setCargandoCallback(false)
  }

  const retrocederPaso = () => {
    const pasoARetroceder = paso >= 1 ? paso - 1 : 1
    setPaso(pasoARetroceder)
    history.push(MapStepToRoute(`P${pasoARetroceder}`))
  }

  return (
    <>
      <div className="container padding-top-3x padding-bottom-1x">
        <h2>Declaración Jurada</h2>
        <p>Inicie su presentación</p>
      </div>
      <div className="container padding-bottom-3x mb-2">
        <div className="row">
          <div className="col-lg-12 order-md-2">
            <div className="steps flex-sm-nowrap">
              <Link to="#" className={'step ' + (paso === 1 ? 'active' : '')}>
                {paso > 1 && <i className="material-icons check_circle" />}
                <h4 className="step-title">1. Términos y Condiciones</h4>
              </Link>
              <Link to="#" className={'step ' + (paso === 2 ? 'active' : '')}>
                {paso > 2 && <i className="material-icons check_circle" />}
                <h4 className="step-title">2. Datos del Contribuyente</h4>
              </Link>
              <Link to="#" className={'step ' + (paso === 3 ? 'active' : '')}>
                {paso > 3 && <i className="material-icons check_circle" />}
                <h4 className="step-title">
                  3. Datos de la Actividad Comercial
                </h4>
              </Link>
              <Link to="#" className={'step ' + (paso === 4 ? 'active' : '')}>
                {paso > 4 && <i className="material-icons check_circle" />}
                <h4 className="step-title">4. Determinación de la Tasa</h4>
              </Link>
              <Link to="#" className={'step ' + (paso === 5 ? 'active' : '')}>
                {paso > 5 && <i className="material-icons check_circle" />}
                <h4 className="step-title">5. Deducciones y Exclusiones</h4>
              </Link>
              <Link to="#" className={'step ' + (paso === 6 ? 'active' : '')}>
                {paso > 6 && <i className="material-icons check_circle" />}
                <h4 className="step-title">6. Pagos</h4>
              </Link>
              <Link to="#" className={'step ' + (paso === 7 ? 'active' : '')}>
                {paso > 7 && <i className="material-icons check_circle" />}
                <h4 className="step-title">7. Emisión DDJJ</h4>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {props.children}
      <div className="container padding-bottom-2x">
        <div className="form-group">
          <button
            onClick={() => retrocederPaso()}
            className="btn btn-secondary"
          >
            Anterior
          </button>
          <button
            disabled={!puedeAvanzar || cargandoCallback}
            onClick={() => avanzarPaso(callbackAvance)}
            className="btn btn-primary"
          >
            {cargandoCallback
              ? 'Cargando'
              : paso === PASO_MAXIMO
              ? 'Pagar'
              : 'Siguiente'}
          </button>
        </div>
      </div>
    </>
  )
}

DeclaracionJurada.propType = {
  paso: PropTypes.number
}

DeclaracionJurada.defaultProps = {
  onContinue: (e) => console.log('ALGO SUCEDE ACA'),
  puedeAvanzar: true
}
export default DeclaracionJurada
